// extracted by mini-css-extract-plugin
export var boldText = "WeCoc";
export var nudgedIcon = "g1c8V";